const Switch = ({ id, className, wrapperClassName, onClick, checked, text, name, onChange }) => {
  return (
    <span className={`${wrapperClassName}`}>
      <input
        id={id}
        hidden
        className={`${className}`}
        type="checkbox"
        name={name}
        data-assessment-state
        checked={checked}
        onChange={e => onChange?.(e.currentTarget.checked)}
        onClick={onClick}
      />

      <label htmlFor={id} className={`flex items-center cursor-pointer`}>
        <div
          className={`
            self-start mt-[2px] w-[32px] h-[16px] 
            rounded-[500px] flex items-center justify-center shrink-0
            ${checked ? 'bg-black dark:bg-white' : 'bg-gray-300 dark:bg-zinc-400'}
          `}
        >
          <div
            className={`
            bg-white dark:bg-black w-3 h-3 rounded-full transition-transform
              ${checked ? 'translate-x-[8px]' : '-translate-x-[8px]'}
            `}
          ></div>
        </div>

        <div className={`ml-2 text-sm`}>{text}</div>
      </label>
    </span>
  )
}

export default Switch
